import { AutoComplete, Button, Form, Input, InputNumber, message } from 'antd'
import type { FormProps } from 'antd'
import React, { useCallback, useState } from 'react'

import {
  patchTextbookCategory,
  postTextbookCategory,
} from '~/services/textbook-category'
import { ITextbookCategory } from '~/types/textbook-category'

import { ModalFormContainer } from './style'

const LANGUAGES = ['英语', '日语', '韩语', '法语', '西班牙语', '德语'].map(
  (value) => ({ value }),
)

const Index: React.FC<{
  data: Partial<ITextbookCategory>
  addCallback: () => void
}> = (props) => {
  const { data, addCallback } = props

  const [loading, setLoading] = useState(false)
  const onFinish = useCallback<
    Required<FormProps<Partial<ITextbookCategory>>>['onFinish']
  >(
    (value) => {
      setLoading(true)
      if (!data.id) {
        postTextbookCategory(value)
          .then(() => {
            message.success('成功')
            addCallback()
          })
          .catch((err) => {
            message.error(
              err?.response?.data || err?.message || '操作失败，请稍后再试',
            )
          })
          .finally(() => {
            setLoading(false)
          })
      } else {
        patchTextbookCategory(data.id, {
          ...value,
          seriesName: value.seriesName || '',
        })
          .then(() => {
            message.success('成功')
            addCallback()
          })
          .catch((err) => {
            message.error(
              err?.response?.data || err?.message || '操作失败，请稍后再试',
            )
          })
          .finally(() => {
            setLoading(false)
          })
      }
    },
    [data.id, addCallback],
  )

  return (
    <ModalFormContainer>
      <Form
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        autoComplete="off"
        initialValues={{ language: '英语', ...data }}
        onFinish={onFinish}
      >
        <Form.Item
          label="分类名称"
          name="name"
          rules={[{ required: true, message: '请输入分类名称' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="系列" name="seriesName">
          <Input />
        </Form.Item>
        <Form.Item
          label="语种"
          name="language"
          tooltip="学生端按 人群 / 语种 / 体系 筛选教材；留空按英语"
          rules={[{ max: 16, message: '最多 16 个字符' }]}
        >
          <AutoComplete options={LANGUAGES} placeholder="英语" />
        </Form.Item>
        <Form.Item label="父分类ID" name="parentId">
          <InputNumber
            placeholder="0为一级分类"
            style={{ width: 150 }}
            disabled
          />
        </Form.Item>
        <Form.Item label="排序" name="order">
          <InputNumber style={{ width: 150 }} />
        </Form.Item>
        <Form.Item label="备注" name="remark">
          <Input />
        </Form.Item>
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button loading={loading} type="primary" htmlType="submit">
            提交
          </Button>
        </Form.Item>
      </Form>
    </ModalFormContainer>
  )
}

export default Index
